import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateStudentType, EnrollmentType, StudentCertificateType, StudentGrade, StudentList, StudentType } from '../../../types/Student';

const studentInitialState: StudentType = {
  idUser: '',
  studentUniversalCode: ''
}
const studentCertificateInitialState: StudentCertificateType = {
  grades: [],
  student: {
    idUser: '',
    id: undefined,
    enrollmentDate: undefined,
    studentUniversalCode: '',
    idFaculty: undefined,
    idDepartament: undefined,
    idCourse: undefined,
    faculty: undefined,
    departament: undefined,
    course: undefined,
    idEnrollment: undefined,
    fullname: undefined
  }
}
const enrollmentInitialState: EnrollmentType = {
  id: '',
  idStudent: '',
  idAcademicYear: '',
  idCourse: '',
  idPlan: '',
  academicYear: '',
  course: '',
  student: '',
  idUser: '',
  date: '',
  status: false
}
const initialState: CreateStudentType = {
  user: {
    id: undefined,
    name: '',
    userName: '',
    email: '',
    bi: '',
    nuit: '',
    phoneNumber: '',
    dateOfBirth: '',
    gender: 'M',
    role: undefined,
    password: undefined,
    isForeign: false
  },
  documents: [],
  enrollment: {
    idStudent: undefined,
    idCourse: '',
    date: undefined,
    idAcademicYear: undefined
  },
  students: {},
  idUniversity: '',
  idFaculty: '',
  idDepartament: '',
  idPlan: '',
  subscribeStudent: false,
  isInternStudent: false,
  // isForeign: false
}

const studentSlice = createSlice({
  name: "studentForm",
  initialState,
  reducers: {
    setUpdateEnrollmentData: (
      state, action: PayloadAction<CreateStudentType>,
    ) => {
      return { ...state, ...action.payload };
    },
    resetUpdateEnrollmentData: (
      state,
    ) => {
      return initialState
    },
    setStudentData: (
      state, action: PayloadAction<StudentType>
    ) => {
      state.student = action.payload;
    },
    resetStudentData: (state) => {
      state.student = studentInitialState
    },
    setEnrollmentData: (
      state, action: PayloadAction<EnrollmentType>
    ) => {
      state.enrollment = action.payload;
    },
    setStudentListData: (
      state, action: PayloadAction<StudentList>
    ) => {
      state.students = action.payload;
    },
    resetStudentListData: (
      state
    ) => {
      state.students = {};
    },
    setStudentCertificateData: (
      state, action: PayloadAction<StudentCertificateType>
    ) => {
      state.certificate = action.payload;
    },
    resetStudentCertificateData: (
      state
    ) => {
      state.certificate = studentCertificateInitialState
    },
    resetEnrollmentData: (state) => {
      state.enrollment = enrollmentInitialState
    },
    setStudentGradeData: (
      state, action: PayloadAction<StudentGrade>
    ) => {
      state.studentsGrades = action.payload;
    },
    resetStudentGradeData: (
      state
    ) => {
      state.studentsGrades = {};
    },

  },

});

export const { setUpdateEnrollmentData, resetUpdateEnrollmentData, setStudentData, resetStudentData, setEnrollmentData, resetEnrollmentData, setStudentCertificateData, resetStudentListData, setStudentListData, setStudentGradeData, resetStudentGradeData } = studentSlice.actions

export default studentSlice.reducer